import { z } from "zod";
import { whatsappTemplateSchema } from "./whatsappTemplateSchema";
import { useBodyField } from "../../../components/WhatsappTemplate/useBodyField";

const translationPath = "chatBot.page.templates.whatsapp_template.errors.";

export const useWhatsappTemplateSchema = (software: "MarCom" | "ChatBot") => {
  const { calcTotalCaracters } = useBodyField();

  const customWhatsappTemplateSchema = whatsappTemplateSchema.superRefine(
    (val, ctx) => {
      const totalCharacters = calcTotalCaracters(
        val.body,
        val.characterLimitRequests,
      );

      if (
        typeof val.fileFixed !== "boolean" &&
        (software === "MarCom" ||
          (software === "ChatBot" && val.ticketAutomation.code === "8")) &&
        (val.headerType?.code === "2" || val.headerType?.code === "4")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["fileFixed"],
          message: translationPath + "file_fixed",
        });
      }
      if (!val.actionType) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["actionType"],
          message: translationPath + "action_type",
        });
      }
      if (
        !val.mediaFile &&
        (val.headerType?.code == "2" || val.headerType?.code == "4")
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["mediaFile"],
          message: translationPath + "media_file",
        });
      }
      if (
        val.whatsMetaCategory &&
        val.whatsMetaCategory.name === "UTILITY" &&
        totalCharacters > 550
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["body"],
          message: translationPath + "body_max_550",
        });
      }
      if (
        val.whatsMetaCategory &&
        val.whatsMetaCategory.name === "MARKETING" &&
        totalCharacters > 1024
      ) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["body"],
          message: translationPath + "body_max",
        });
      }
      if (val.invalidVariables) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ["body"],
          message: translationPath + "body_invalid_variables",
        });
      }
      if (val.ctaButtons?.length && val.ctaButtons.length > 0) {
        val.ctaButtons.forEach((ctaButton, index) => {
          if (ctaButton.actionType.id === "2") {
            const urlRegex = /^https?:\/\/.+/i;
            const value = ctaButton.payload;
            console.log(ctaButton.payload);
            if (typeof value !== "string" || !urlRegex.test(value.trim())) {
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ["ctaButtons", index, "payload"],
                message: translationPath + "url_payload",
              });
            }
          }
        });
      }
    },
  );

  return {
    customWhatsappTemplateSchema,
  };
};
